<ng-container *ngFor="let pageToReview of flow?.reviewablePages">
  <section *ngIf="isMyReviewContainer(page)">
    <cu-review-page-renderer-resolver [page]="pageToReview" [flow]="flow" ></cu-review-page-renderer-resolver>
  </section>
</ng-container>
